module.exports = __webpack_public_path__ + "img/js_logo_icon_web.a0969095.png";